import INFTCollections from '../../models/INFTCollections'
import AvaxtarsCard from '../../nftFormats/Avaxtars/Card/AvaxtarsCard'
import AvaxtarsDetail from '../../nftFormats/Avaxtars/Detail/AvaxtarsDetail'
import AvaxtarsActivtyDetail from '../../nftFormats/Avaxtars/Activity/AvaxtarsActivityDetail'
import AvaxtarsLogo from '../../../../assets/nft-logo/Avaxtars.jpg'

export const AvaxtarsData: INFTCollections[] = [
  {
    id: 'Avaxtars',
    tokenAddress: '0x53d2230eac25643cd0772b310eebb569a100ea73',
    name: 'Avaxtars Gen1',
    cardFormat: AvaxtarsCard,
    detailFormat: AvaxtarsDetail,
    activityFormat: AvaxtarsActivtyDetail,
    category: 2,
    creatorAddress: '0x50423e551035f9f920089c2a23b225dc0d995d58',
    logo: AvaxtarsLogo,
    website: 'https://avaxtars.com/',
    telegram: 'https://t.me/AvaxtarsGlobal'
  }
]

export const AvaxtarsCategoryData = {
  [AvaxtarsData[0].tokenAddress.toLowerCase()]: AvaxtarsData[0].category
}
